export default (cart) => {
	const accountStatus = cart.account.status || {};
	const createAccount = cart.theme.variables.createAccount;

	return {
		event: 'userData',
		account: {
			MyAccount: createAccount ? `${accountStatus.MyAccount} | ${accountStatus.shadow} | ${accountStatus.verified}` : 'disabled',
			paired: createAccount ? accountStatus.paired : 'disabled'
		}
	};
};
